import { api, multipartApi } from './networkService';

class DriverService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/driver`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch driver error:', error);
            throw error;
        }
    }

    static async fetchAll(filters) {
        try {
            const response = await api.get(`api/user/driver`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch driver error:', error);
            throw error;
        }
    }

    static async fetchAllWithStreets() {
        try {
            const response = await api.get(`api/user/driver/all/streets`);
            return response.data;
        } catch (error) {
            console.error('Fetch driver error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/driver/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch driver error:', error);
            throw error;
        }
    }

    static async add(driver) {
        try {
            const response = await multipartApi.post(`api/user/driver`, driver);
            return response;
        } catch (error) {
            console.error('Add driver error:', error);
            throw error;
        }
    }

    static async update(id, driver) {
        try {
            const response = await multipartApi.put(`api/user/driver/${id}`, driver);
            return response;
        } catch (error) {
            console.error('Update driver error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/driver/${id}`);
            return response;
        } catch (error) {
            console.error('Delete driver error:', error);
            throw error;
        }
    }
}

export default DriverService;
